import React from 'react';

export default function LeftChevronNew({ className }) {
    return (
        <svg
            className={className}
            width="6"
            height="12"
            viewBox="0 0 6 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.08303 12L0 11.0711L4.3471 6L0 0.928894L1.08303 0L5.82823 5.53627C6.05725 5.80309 6.05725 6.19762 5.82823 6.46445L1.08303 12Z"
                fill="#0C2340"
            />
        </svg>
    );
}
